import PropTypes from "prop-types";
import React from "react";

import DrawerFilters, {
  DrawerFilterChips,
  DrawerFiltersList,
} from "../../../../modules/drawer-filters";
import Search from "../../../../ui library/components/filters/search";

export default function ProviderFilters({ filters, updateFilter, filterState, activeFilters }) {
  return (
    <>
      <div className="mb-4 flex w-full flex-col gap-4 xl:flex-row xl:items-center">
        <div className="min-w-0 flex-1">
          <Search
            id="search"
            placeholder="Search by Provider Name, Address, City, State."
            filters={filters}
            updateFilter={updateFilter}
          />
        </div>
        <div className="h-[40px] w-full xl:w-auto">
          <DrawerFilters
            buttonTittle="Filter"
            drawTittle="Filters"
            triggerId="provider-manager-filters-button"
            closeButtonId="provider-manager-filters-close-button"
          >
            <DrawerFiltersList
              filterState={filterState}
              options={{ replaceNavigation: false }}
            />
          </DrawerFilters>
        </div>
      </div>
      <DrawerFilterChips
        activeFilters={activeFilters}
        queryParamsOptions={{ replaceNavigation: false }}
      />
    </>
  );
}

ProviderFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  updateFilter: PropTypes.func.isRequired,
  filterState: PropTypes.array.isRequired,
  activeFilters: PropTypes.array.isRequired,
};
